import Link from "next/link"
import { BookOpen, Facebook, Twitter, Instagram, Linkedin, Mail, Phone } from "lucide-react"
import { Button } from "@/components/ui/button"

export function Footer() {
  return (
    <footer className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background to-muted/50 dark:from-background dark:to-card" />
      <div className="absolute top-0 left-0 w-96 h-96 bg-primary/5 rounded-full blur-[100px]" />

      <div className="relative pt-24 pb-12 border-t border-white/20 dark:border-white/10">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 text-right mb-16">
            {/* Brand Section */}
            <div className="space-y-6">
              <Link href="/" className="flex items-center gap-3 justify-end group">
                <span className="text-2xl font-black tracking-tight text-foreground group-hover:text-primary transition-colors">
                  تعلّم
                </span>
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary to-secondary text-white group-hover:scale-110 transition-transform shadow-lg">
                  <BookOpen className="h-6 w-6" />
                </div>
              </Link>
              <p className="text-sm text-foreground/60 leading-relaxed">
                منصة تعليمية عربية متخصصة في توفير دورات عالية الجودة لتطوير مهاراتك المهنية.
              </p>
              <div className="flex items-center gap-3 justify-end">
                {[
                  { icon: Facebook, href: "#" },
                  { icon: Twitter, href: "#" },
                  { icon: Instagram, href: "#" },
                  { icon: Linkedin, href: "#" },
                ].map(({ icon: Icon, href }, i) => (
                  <Link key={i} href={href}>
                    <Button
                      variant="outline"
                      size="icon"
                      className="rounded-full h-10 w-10 border-2 border-white/40 hover:bg-primary hover:text-white hover:border-primary transition-all bg-transparent"
                    >
                      <Icon className="h-5 w-5" />
                    </Button>
                  </Link>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className="space-y-6">
              <h3 className="text-lg font-black tracking-wide">روابط سريعة</h3>
              <ul className="space-y-3 text-sm">
                {[
                  { label: "الدورات", href: "/courses" },
                  { label: "المدربون", href: "/instructors" },
                  { label: "عن المنصة", href: "/about" },
                  { label: "اتصل بنا", href: "/contact" },
                ].map(({ label, href }) => (
                  <li key={label}>
                    <Link href={href} className="text-foreground/60 hover:text-primary font-medium transition-colors">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support */}
            <div className="space-y-6">
              <h3 className="text-lg font-black tracking-wide">الدعم</h3>
              <ul className="space-y-3 text-sm">
                {[
                  { label: "الأسئلة الشائعة", href: "/faq" },
                  { label: "سياسة الخصوصية", href: "/privacy" },
                  { label: "شروط الخدمة", href: "/terms" },
                ].map(({ label, href }) => (
                  <li key={label}>
                    <Link href={href} className="text-foreground/60 hover:text-primary font-medium transition-colors">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="space-y-6">
              <h3 className="text-lg font-black tracking-wide">تواصل معنا</h3>
              <ul className="space-y-4 text-sm">
                <li className="flex items-center gap-3 justify-end text-foreground/60">
                  <span>info@taalam.com</span>
                  <Mail className="h-5 w-5 text-primary" />
                </li>
                <li className="flex items-center gap-3 justify-end text-foreground/60">
                  <span>+966 50 000 0000</span>
                  <Phone className="h-5 w-5 text-primary" />
                </li>
              </ul>
              <div className="pt-4 space-y-3">
                <p className="text-xs font-bold uppercase text-muted-foreground">اشترك بالنشرة الإخبارية</p>
                <div className="flex gap-2">
                  <Button className="rounded-lg px-4 h-10 text-xs font-bold shadow-md">اشترك</Button>
                  <input
                    type="email"
                    placeholder="بريدك"
                    className="flex-1 bg-white/10 dark:bg-white/5 border-2 border-white/40 rounded-lg px-4 text-sm text-right placeholder-foreground/40 focus:outline-none focus:border-primary transition-colors"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-white/20 dark:border-white/10 text-center">
            <p className="text-xs text-foreground/50 font-medium">
              © {new Date().getFullYear()} منصة تعلّم. جميع الحقوق محفوظة.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
